import mutations from './mutations'
import getters from './getters'
import actions from './actions'

const state = {
  conferencias: [],
  dadosRelatorioConferencia: [],
}

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state,
}
